import React from "react";
import "../../Assets/Style/bootstrap/min.css";
import "../../Assets/Style/custom-styles/main.scss";
import "../../Assets/Style/custom-styles/custom-styles.css";
// import "../../Assets/Style/fontawesome/css/all.css";
import icon from '../../Assets/images/favicon.ico'
import { Helmet } from "react-helmet"
export default function HeaderSection(props) {
  return (

    <div className="banner-section">
      <Helmet>
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href={icon}
        />
        <script src="https://reviewsonmywebsite.com/js/v2/embed.js?id=c338ae55b38e487f19ae" type="text/javascript"></script>
      </Helmet>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-3">
            <div className="top-section bg-white">
              <h2 className="text-gray">
                {props.city}, {props.state}
              </h2>
              <h1 className="text-orange">
                {props?.heroSection?.content?.Header}
              </h1>
            </div>
          </div>

          <div className="col-md-7">
            <div className="quote-here">
              <div className="row">
                <div className="col-md-8">
                  <div className="left-col">
                    <h2>{props?.heroSection?.content?.Section1[0]?.Heading}</h2>
                    <span className="mobile_text while-link">
                      {props?.RightImage?.content?.list_item[0]?.list_text}:{" "}
                      <u>
                        <a href={'tel:' + props?.RightImage?.content?.list_item[0]
                          ?.description?.content[0]?.content[0]?.text}>  {
                            props?.RightImage?.content?.list_item[0]
                              ?.description?.content[0]?.content[0]?.text
                          }</a>

                      </u>
                    </span>

                    <h1>
                      <a
                        href={
                          props?.bannerData[0]?.content?.buttons[0]?.link_url
                        }
                        target={
                          props?.bannerData[0]?.content?.buttons[0]?.link_target
                        }
                      >
                        <button className="btn btn_quick-quote-section">
                          {
                            props?.heroSection?.content?.Section1[0]
                              ?.Sub_Heading
                          }
                        </button>
                      </a>
                      <div className="sub-text text-white text-center">
                        <span className="dektop_text while-link">
                          {props?.RightImage?.content?.list_item[0]?.list_text}:{" "}
                          <u>
                            <a href={'tel:' + props?.RightImage?.content?.list_item[0]
                              ?.description?.content[0]?.content[0]?.text}>  {
                                props?.RightImage?.content?.list_item[0]
                                  ?.description?.content[0]?.content[0]?.text
                              }</a>

                          </u>
                        </span>
                      </div>
                    </h1>
                    {/* <h3>Call us at: 844-358-5605</h3> */}
                  </div>
                </div>
                <div className="col-md-4">
                  <img
                    src={props?.heroSection?.content?.Background?.filename}
                    className="img-fluid banner_image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
